import React from 'react'
import { Input } from '../input'
import ActivityItem from './admin-dashboard-activities-item'
import { AnnouncementCardWrapper, AnnouncementCardTopSection, InputContainer } from './admin-dashboard-activities.style'
import { SelectContainer } from "../dashboard-overview/dashboard-overview.style";
import { MdSearch } from 'react-icons/md'



const AdminDashboardActivities = ({ search, scroll }) => {
    return (
        <div>
            {/* <ModuleHeader>
                <span>Announcements</span>
                <Hr />
            </ModuleHeader> */}
            <AnnouncementCardWrapper scroll={scroll}>
                {search ? (
                    <AnnouncementCardTopSection>
                        <InputContainer>
                            <Input
                                startAdornment={<MdSearch />}
                                placeholder='Search'
                                className="search"
                            />
                        </InputContainer>

                        <SelectContainer style={{ marginLeft: 'auto' }}>
                            <select>
                                <option value="">Sort by</option>
                                <option value="date">Date</option>
                                <option value="time">Time</option>
                                <option value="day">Day</option>
                            </select>
                        </SelectContainer>
                    </AnnouncementCardTopSection>
                ) : null}
                <ActivityItem />
                <ActivityItem />
                <ActivityItem />
                <ActivityItem />
                <ActivityItem />
            </AnnouncementCardWrapper>
        </div>
    )
}

export { AdminDashboardActivities }
